module.exports = __webpack_public_path__ + "img/r-cb6-110-2.36f67ff6.gif";